// eslint-disable-next-line import/prefer-default-export
export const TRANSLATIONS = {
  auth: {
    sign_in: "auth.sign_in",
    email: "auth.email",
    password: "auth.password",
    sign_in_failed: "auth.sign_in_failed",
    server_unreachable: "auth.server_unreachable",
    welcome_back: "auth.welcome_back",
    sign_in_hint: "auth.sign_in_hint",
    email_placeholder: "auth.email_placeholder",
    signing_in: "auth.signing_in",
    enter_email_password: "auth.enter_email_password",
  },
  global: {
    sign_out: "global.sign_out",
    cancel: "global.cancel",
    save: "global.save",
    saving: "global.saving",
    adding: "global.adding",
    deleting: "global.deleting",
    delete_confirm_title: "global.delete_confirm_title",
    error_failed: "global.error_failed",
    reset_filters: "global.reset_filters",
  },
  login: {
    badge: "login.badge",
    headline: "login.headline",
    highlight_organizations: "login.highlight_organizations",
    highlight_probes: "login.highlight_probes",
    highlight_roles: "login.highlight_roles",
  },
  navigation: {
    menu: "navigation.menu",
    overview: "navigation.overview",
    organizations: "navigation.organizations",
    details: "navigation.details",
    home: "navigation.home",
    toggle_sidebar: "navigation.toggle_sidebar",
    breadcrumb: "navigation.breadcrumb",
    language: "navigation.language",
    roles: "navigation.roles",
    users: "navigation.users",
    groups: "navigation.groups",
    section_organization: "navigation.section_organization",
    section_probes: "navigation.section_probes",
    sensor_types: "navigation.sensor_types",
    config_fields: "navigation.config_fields",
    field_permissions: "navigation.field_permissions",
    section_mine: "navigation.section_mine",
    my_sessions: "navigation.my_sessions",
    my_configurations: "navigation.my_configurations",
    my_organization: "navigation.my_organization",
  },
  overview: {
    welcome: "overview.welcome",
    subtitle: "overview.subtitle",
  },
  stats: {
    totals: "stats.totals",
    organizations: "stats.organizations",
    users: "stats.users",
    sessions: "stats.sessions",
    my_sessions: "stats.my_sessions",
  },
  organizations: {
    subtitle: "organizations.subtitle",
    search: "organizations.search",
    since: "organizations.since",
    no_matches: "organizations.no_matches",
    no_matches_hint: "organizations.no_matches_hint",
    empty: "organizations.empty",
    empty_hint: "organizations.empty_hint",
    add: "organizations.add",
    add_description: "organizations.add_description",
    name: "organizations.name",
    notes: "organizations.notes",
    adding: "organizations.adding",
    error_name_required: "organizations.error_name_required",
    error_name_too_long: "organizations.error_name_too_long",
    error_forbidden: "organizations.error_forbidden",
    error_failed: "organizations.error_failed",
  },
  organization: {
    fallback_title: "organization.fallback_title",
    all: "organization.all",
    people: "organization.people",
    search_people: "organization.search_people",
    all_roles: "organization.all_roles",
    filter_by_role: "organization.filter_by_role",
    column_person: "organization.column_person",
    column_role: "organization.column_role",
    column_joined: "organization.column_joined",
    no_people_match: "organization.no_people_match",
    no_people: "organization.no_people",
  },
  pagination: {
    total: "pagination.total",
    page_of: "pagination.page_of",
    previous: "pagination.previous",
    next: "pagination.next",
  },
  forbidden: {
    title: "forbidden.title",
    text: "forbidden.text",
  },
  roles: {
    subtitle: "roles.subtitle",
    search: "roles.search",
    add: "roles.add",
    add_description: "roles.add_description",
    adding: "roles.adding",
    name: "roles.name",
    description: "roles.description",
    description_placeholder: "roles.description_placeholder",
    no_description: "roles.no_description",
    organization_label: "roles.organization_label",
    imko_wide: "roles.imko_wide",
    permissions: "roles.permissions",
    no_permissions: "roles.no_permissions",
    perm_super_admin: "roles.perm_super_admin",
    perm_super_admin_short: "roles.perm_super_admin_short",
    perm_super_admin_hint: "roles.perm_super_admin_hint",
    perm_company_admin: "roles.perm_company_admin",
    perm_manage_users: "roles.perm_manage_users",
    users_count: "roles.users_count",
    delete: "roles.delete",
    delete_confirm_title: "roles.delete_confirm_title",
    delete_confirm_text: "roles.delete_confirm_text",
    deleting: "roles.deleting",
    in_use: "roles.in_use",
    empty: "roles.empty",
    no_matches: "roles.no_matches",
    error_name_required: "roles.error_name_required",
    error_super_admin_org: "roles.error_super_admin_org",
    error_failed: "roles.error_failed",
    error_delete_in_use: "roles.error_delete_in_use",
    error_delete_failed: "roles.error_delete_failed",
    subtitle_company: "roles.subtitle_company",
    group_defaults: "roles.group_defaults",
    group_defaults_hint: "roles.group_defaults_hint",
    default_badge: "roles.default_badge",
    default_locked: "roles.default_locked",
    super_admin_global: "roles.super_admin_global",
    edit: "roles.edit",
    edit_description: "roles.edit_description",
    save: "roles.save",
    saving: "roles.saving",
    name_locked: "roles.name_locked",
    error_forbidden: "roles.error_forbidden",
    error_reserved_name: "roles.error_reserved_name",
    perm_manage_groups: "roles.perm_manage_groups",
    perm_see_organization: "roles.perm_see_organization",
    implied_by_manage_users: "roles.implied_by_manage_users",
  },
  users: {
    subtitle_all: "users.subtitle_all",
    subtitle_org: "users.subtitle_org",
    all_organizations: "users.all_organizations",
    imko: "users.imko",
    filter_by_organization: "users.filter_by_organization",
    column_organization: "users.column_organization",
    no_users: "users.no_users",
    column_groups: "users.column_groups",
    filter_by_group: "users.filter_by_group",
    delete: "users.delete",
    delete_confirm_text: "users.delete_confirm_text",
    delete_self: "users.delete_self",
    add: "users.add",
    add_description: "users.add_description",
    name: "users.name",
    choose_role: "users.choose_role",
    error_required: "users.error_required",
    error_email_taken: "users.error_email_taken",
    language: "users.language",
    language_hint: "users.language_hint",
    unlock_code: "users.unlock_code",
    unlock_code_hint: "users.unlock_code_hint",
    unlock_code_set: "users.unlock_code_set",
    unlock_code_title: "users.unlock_code_title",
    unlock_code_description: "users.unlock_code_description",
  },
  groups: {
    subtitle_all: "groups.subtitle_all",
    subtitle_org: "groups.subtitle_org",
    search: "groups.search",
    add: "groups.add",
    add_description: "groups.add_description",
    adding: "groups.adding",
    name: "groups.name",
    description: "groups.description",
    description_placeholder: "groups.description_placeholder",
    members_count: "groups.members_count",
    members: "groups.members",
    no_members: "groups.no_members",
    empty: "groups.empty",
    empty_hint: "groups.empty_hint",
    no_matches: "groups.no_matches",
    all: "groups.all",
    edit: "groups.edit",
    edit_description: "groups.edit_description",
    save: "groups.save",
    saving: "groups.saving",
    delete: "groups.delete",
    delete_confirm_title: "groups.delete_confirm_title",
    delete_confirm_text: "groups.delete_confirm_text",
    deleting: "groups.deleting",
    add_members: "groups.add_members",
    add_members_description: "groups.add_members_description",
    add_selected: "groups.add_selected",
    everyone_added: "groups.everyone_added",
    remove_member: "groups.remove_member",
    read_only: "groups.read_only",
    error_name_required: "groups.error_name_required",
    error_duplicate: "groups.error_duplicate",
    error_members: "groups.error_members",
    error_forbidden: "groups.error_forbidden",
    error_failed: "groups.error_failed",
  },
  sensor_types: {
    subtitle: "sensor_types.subtitle",
    add: "sensor_types.add",
    add_description: "sensor_types.add_description",
    edit: "sensor_types.edit",
    edit_description: "sensor_types.edit_description",
    name: "sensor_types.name",
    key: "sensor_types.key",
    key_hint: "sensor_types.key_hint",
    probe_codes: "sensor_types.probe_codes",
    probe_codes_hint: "sensor_types.probe_codes_hint",
    fields_count: "sensor_types.fields_count",
    records_count: "sensor_types.records_count",
    view_fields: "sensor_types.view_fields",
    delete: "sensor_types.delete",
    delete_confirm_text: "sensor_types.delete_confirm_text",
    in_use: "sensor_types.in_use",
    empty: "sensor_types.empty",
    error_required: "sensor_types.error_required",
    error_duplicate_key: "sensor_types.error_duplicate_key",
    error_codes: "sensor_types.error_codes",
    error_in_use: "sensor_types.error_in_use",
  },
  config_fields: {
    subtitle: "config_fields.subtitle",
    search: "config_fields.search",
    filter_by_sensor_type: "config_fields.filter_by_sensor_type",
    filter_by_group: "config_fields.filter_by_group",
    all_groups: "config_fields.all_groups",
    group_analog_output: "config_fields.group_analog_output",
    group_calibration: "config_fields.group_calibration",
    group_led_colors: "config_fields.group_led_colors",
    group_measure_params: "config_fields.group_measure_params",
    group_other: "config_fields.group_other",
    type_number: "config_fields.type_number",
    type_text: "config_fields.type_text",
    type_color: "config_fields.type_color",
    type_boolean: "config_fields.type_boolean",
    column_label: "config_fields.column_label",
    column_key: "config_fields.column_key",
    column_type: "config_fields.column_type",
    column_unit: "config_fields.column_unit",
    group: "config_fields.group",
    add: "config_fields.add",
    add_description: "config_fields.add_description",
    edit: "config_fields.edit",
    edit_description: "config_fields.edit_description",
    key_hint: "config_fields.key_hint",
    key_warning: "config_fields.key_warning",
    delete: "config_fields.delete",
    delete_confirm_text: "config_fields.delete_confirm_text",
    count: "config_fields.count",
    empty: "config_fields.empty",
    error_required: "config_fields.error_required",
    error_duplicate_key: "config_fields.error_duplicate_key",
    error_in_use: "config_fields.error_in_use",
  },
  field_permissions: {
    subtitle: "field_permissions.subtitle",
    filter_organization: "field_permissions.filter_organization",
    filter_sensor_type: "field_permissions.filter_sensor_type",
    company_admin_note: "field_permissions.company_admin_note",
    column_field: "field_permissions.column_field",
    toggle_all: "field_permissions.toggle_all",
    toggle_group: "field_permissions.toggle_group",
    editable_count: "field_permissions.editable_count",
    unsaved: "field_permissions.unsaved",
    discard: "field_permissions.discard",
    no_roles: "field_permissions.no_roles",
    no_roles_hint: "field_permissions.no_roles_hint",
    no_fields: "field_permissions.no_fields",
  },
  not_found: {
    title: "not_found.title",
    text: "not_found.text",
    back: "not_found.back",
  },
  my_data: {
    subtitle_sessions: "my_data.subtitle_sessions",
    subtitle_configurations: "my_data.subtitle_configurations",
    search_sessions: "my_data.search_sessions",
    search_configurations: "my_data.search_configurations",
    all_probe_types: "my_data.all_probe_types",
    filter_probe_type: "my_data.filter_probe_type",
    from: "my_data.from",
    to: "my_data.to",
    clear_dates: "my_data.clear_dates",
    export_csv: "my_data.export_csv",
    column_name: "my_data.column_name",
    column_probe: "my_data.column_probe",
    column_recorded: "my_data.column_recorded",
    column_saved: "my_data.column_saved",
    column_measurements: "my_data.column_measurements",
    column_moisture: "my_data.column_moisture",
    column_field: "my_data.column_field",
    column_value: "my_data.column_value",
    empty_sessions: "my_data.empty_sessions",
    empty_sessions_hint: "my_data.empty_sessions_hint",
    empty_configurations: "my_data.empty_configurations",
    empty_configurations_hint: "my_data.empty_configurations_hint",
    no_match: "my_data.no_match",
    open: "my_data.open",
    trash: "my_data.trash",
    trash_session_text: "my_data.trash_session_text",
    trash_configuration_text: "my_data.trash_configuration_text",
    back_sessions: "my_data.back_sessions",
    back_configurations: "my_data.back_configurations",
    details: "my_data.details",
    comment: "my_data.comment",
    device: "my_data.device",
    measure_mode: "my_data.measure_mode",
    calibration: "my_data.calibration",
    layout: "my_data.layout",
    average_mode: "my_data.average_mode",
    std_dev: "my_data.std_dev",
    yes: "my_data.yes",
    no: "my_data.no",
    averages: "my_data.averages",
    moisture: "my_data.moisture",
    temperature: "my_data.temperature",
    conductivity: "my_data.conductivity",
    tp: "my_data.tp",
    measurements: "my_data.measurements",
    no_measurements: "my_data.no_measurements",
    time: "my_data.time",
    point: "my_data.point",
    transit_time: "my_data.transit_time",
    depth: "my_data.depth",
    angle: "my_data.angle",
    density: "my_data.density",
    recipe: "my_data.recipe",
    measurement_type: "my_data.measurement_type",
    latitude: "my_data.latitude",
    longitude: "my_data.longitude",
    values: "my_data.values",
    no_values: "my_data.no_values",
    probe_type: "my_data.probe_type",
    serial_number: "my_data.serial_number",
    trash_confirm_title: "my_data.trash_confirm_title",
    sort_oldest_first: "my_data.sort_oldest_first",
    sort_newest_first: "my_data.sort_newest_first",
    download_csv: "my_data.download_csv",
  },
  set_password: {
    title: "set_password.title",
    subtitle: "set_password.subtitle",
    password: "set_password.password",
    confirm: "set_password.confirm",
    hint: "set_password.hint",
    save: "set_password.save",
    saving: "set_password.saving",
    done: "set_password.done",
    to_login: "set_password.to_login",
    error_short: "set_password.error_short",
    error_mismatch: "set_password.error_mismatch",
    error_link: "set_password.error_link",
  },
  forgot_password: {
    link: "forgot_password.link",
    title: "forgot_password.title",
    subtitle: "forgot_password.subtitle",
    send: "forgot_password.send",
    sending: "forgot_password.sending",
    sent: "forgot_password.sent",
    back: "forgot_password.back",
    error_email: "forgot_password.error_email",
  },
} as const;
